import React from 'react';

import Icon from '../../Icon';

// eslint-disable-next-line react/prop-types
function getPrefix({ prefix, size


}) {
  if (!prefix) {return null;}

  return typeof prefix === 'string' ?
  <Icon name={prefix} size={size} /> :
  prefix;
}

export default getPrefix;